import { BehaviorSubject } from "rxjs";
import { EventEmitter } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { IFilter } from "../services/IFilter";
import { AuthService } from "../services/auth.service";

export class CmdbApplicationFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService) {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(value:any) {
    this.companyIdChange.next(value);
    this.emitChange("companyId", value);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(value:any) {
    this.nameChange.next(value);
    this.emitChange("name", value);
  }

  applicationTagNameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get applicationTagName():any {
    return this.applicationTagNameChange.value;
  }
  set applicationTagName(value:any) {
    this.applicationTagNameChange.next(value);
    this.emitChange("applicationTagName", value);
  }

  businessCriticalityChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get businessCriticality():any {
    return this.businessCriticalityChange.value;
  }
  set businessCriticality(value:any) {
    this.businessCriticalityChange.next(value);
    this.emitChange("businessCriticality", value);
  }

  operationalStatusChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get operationalStatus():any {
    return this.operationalStatusChange.value;
  }
  set operationalStatus(value:any) {
    this.operationalStatusChange.next(value);
    this.emitChange("operationalStatus", value);
  }

  assetTagChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get assetTag():any {
    return this.assetTagChange.value;
  }
  set assetTag(value:any) {
    this.assetTagChange.next(value);
    this.emitChange("assetTag", value);
  }

  businessOwnerChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get businessOwner():any {
    return this.businessOwnerChange.value;
  }
  set businessOwner(value:any) {
    this.businessOwnerChange.next(value);
    this.emitChange("businessOwner", value);
  }

  businessDepartmentChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get businessDepartment():any {
    return this.businessDepartmentChange.value;
  }
  set businessDepartment(value:any) {
    this.businessDepartmentChange.next(value);
    this.emitChange("businessDepartment", value);
  }

  itOwnerChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get itOwner():any {
    return this.itOwnerChange.value;
  }
  set itOwner(value:any) {
    this.itOwnerChange.next(value);
    this.emitChange("itOwner", value);
  }

  itDepartmentChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get itDepartment():any {
    return this.itDepartmentChange.value;
  }
  set itDepartment(value:any) {
    this.itDepartmentChange.next(value);
    this.emitChange("itDepartment", value);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.applicationTagName && this.applicationTagName !== '') {
      params = params.set("applicationTagName", this.applicationTagName);
    }
    if (this.businessCriticality && this.businessCriticality !== '') {
      params = params.set("businessCriticality", this.businessCriticality);
    }
    if (this.operationalStatus && this.operationalStatus !== '') {
      params = params.set("operationalStatus", this.operationalStatus);
    }
    if (this.assetTag && this.assetTag !== '') {
      params = params.set("assetTag", this.assetTag);
    }
    if (this.businessOwner && this.businessOwner !== '') {
      params = params.set("businessOwner", this.businessOwner);
    }
    if (this.businessDepartment && this.businessDepartment !== '') {
      params = params.set("businessDepartment", this.businessDepartment);
    }
    if (this.itOwner && this.itOwner !== '') {
      params = params.set("itOwner", this.itOwner);
    }
    if (this.itDepartment && this.itDepartment !== '') {
      params = params.set("itDepartment", this.itDepartment);
    }

    return params;
  }

  setFilters(props: any): void {
    this.companyIdChange.next(props.companyId === undefined ? this.auth.getCompanyId() : props.companyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.applicationTagNameChange.next(props.applicationTagName || undefined);
    this.businessCriticalityChange.next(props.businessCriticality || undefined);
    this.operationalStatusChange.next(props.operationalStatus || undefined);
    this.assetTagChange.next(props.assetTag || undefined);
    this.businessOwnerChange.next(props.businessOwner || undefined);
    this.businessDepartmentChange.next(props.businessDepartment || undefined);
    this.itOwnerChange.next(props.itOwner || undefined);
    this.itDepartmentChange.next(props.itDepartment || undefined);
  }

  toObj() {
    let obj:any = {};

    obj.companyId = this.companyId;
    obj.name = this.name;
    obj.applicationTagName = this.applicationTagName;
    obj.businessCriticality = this.businessCriticality;
    obj.operationalStatus = this.operationalStatus;
    obj.assetTag = this.assetTag;
    obj.businessOwner = this.businessOwner;
    obj.businessDepartment = this.businessDepartment;
    obj.itOwner = this.itOwner;
    obj.itDepartment = this.itDepartment;
 
    return obj;
  }

  public clear():void {
    this.companyId = this.auth.getCompanyId();
    this.name = undefined;
    this.applicationTagName = undefined;
    this.businessCriticality = undefined;
    this.operationalStatus = undefined;
    this.assetTag = undefined;
    this.businessOwner = undefined;
    this.businessDepartment = undefined;
    this.itOwner = undefined;
    this.itDepartment = undefined;
  }
}
